import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'
import { useState, useEffect } from 'react'
import JSONInput from 'react-json-editor-ajrm'
import locale from 'react-json-editor-ajrm/locale/en'

import { Button } from '../../common/components/button'
import { Modal } from '../../common/components/modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useStyles } from './manual-block-editor.style'

export const ManualBlockEditor = function ({ block, onChange = () => {} }) {
  const classes = useStyles()

  const [isModalOpen, setIsModalOpen] = useState()
  const [errorMessage, setErrorMessage] = useState('')
  const [blockConfig, setBlockConfig] = useState(block)

  useEffect(() => {
    setBlockConfig(block)
  }, [block])

  function handleEditConfiguration () {
    setIsModalOpen(true)
  }

  function handleModalClose () {
    setBlockConfig(block)
    setIsModalOpen(false)
    setErrorMessage('')
  }

  function handleManualUpdate () {
    onChange(blockConfig)
    setIsModalOpen(false)
    setErrorMessage('')
  }

  function onManualChange ({ jsObject, error }) {
    if (error) {
      setErrorMessage('You must fix the error above before saving.')
    } else {
      setErrorMessage('')
      setBlockConfig(jsObject)
    }
  }

  return <>
    <Button variant="secondary" onClick={handleEditConfiguration}>Manually Edit Configuration</Button>
    <Modal isOpen={isModalOpen} onClose={handleModalClose} title="Configuration" enableOverlayClick={false}
      footer={<>
        {errorMessage &&
          <div className={classes.errorMessageContainer}>
            <FontAwesomeIcon icon={faExclamationTriangle}/>
            <div className={classes.errorMessageText}>
              {errorMessage}
            </div>
          </div>
        }
        <Button variant="secondary" onClick={handleManualUpdate} disabled={!!errorMessage}>Update</Button>
      </>}>
      <div className={classes.container}>
        <JSONInput
          placeholder={blockConfig}
          width='100%'
          height='100%'
          onChange={onManualChange}
          locale={locale}
        />
      </div>
    </Modal>
  </>
}
